<template>
  <section>
    <div class="german">
      <h1>Datenschutzhinweis</h1>
      <p>
        <strong>1. Ilajnafsy und Ihre Daten</strong>
      </p>
      <p>
        Der Schutz und die Vertraulichkeit bei der Nutzung des Ilajnafsy-Programms ist uns sehr
        wichtig. Wir sind uns bewusst, dass wir Sie in unserer Studie um sensible Informationen
        bitten, die einen maximalen Schutz erfordern. Aus diesem Grund erheben wir so wenig
        personenbezogene Daten wie möglich und sichern diese nach höchsten technischen Standards.
      </p>
      <p>
        Die
        <strong>Zentrum ÜBERLEBEN gGmbH, Turmstraße 21, 10559 Berlin</strong> ist für den Schutz
        Ihrer Daten im Sinne der Europäischen Datenschutzverordnung (GDPR) verantwortlich. Richard
        Grünberg ist der Datenschutzbeauftragte. Dr. Maria Böttche (Leiterin der
        Forschungsabteilung) ist für den Prozess der Datenerhebung verantwortlich.
      </p>
      <p>
        Wenn Sie Fragen zu den folgenden Datenschutzhinweisen haben, stehen wir Ihnen gerne zur
        Verfügung.
      </p>
      <p>
        Fragen zum Datenschutz können an:
        <a
          href="mailto:support-ilajnafsy@ueberleben.org"
        >ilajnafsy-online@ueberleben.org</a>
        oder +49 30 303906 71 gerichtet werden.
      </p>
      <p>
        <strong>2. Worum geht es beim Datenschutz?</strong>
      </p>
      <p>
        Beim Datenschutz geht es um den Schutz personenbezogener Daten von Personen. Dies betrifft
        Daten, die sich auf eine identifizierte oder identifizierbare lebende Person beziehen. Dazu
        gehören Informationen wie Name, IP-Adresse, E-Mail-Adresse oder Telefonnummer.
        Informationen, die nicht mit Ihrer Identität in Verbindung gebracht werden können, fallen
        nicht unter diese Kategorie.
      </p>
      <p>
        Wir beschränken uns bei der Erhebung und Nutzung personenbezogener Daten strikt auf das
        technisch Notwendige und halten uns an die gesetzlichen Bestimmungen. Wenn immer möglich,
        verzichten wir auf die Erhebung personenbezogener Daten. Personenbezogene Daten erheben und
        verwenden wir nur, wenn Sie uns Ihre Einwilligung dazu erteilt haben oder wenn wir
        gesetzlich dazu berechtigt sind. Es ist uns wichtig, dass Sie verstehen, welche Daten wir
        erheben, warum wir die Daten erheben und wofür wir sie verwenden.
      </p>
      <p>
        <strong>3. Welche Daten werden erhoben?</strong>
      </p>
      <p>
        Für die Durchführung der Studie erheben und verarbeiten wir die folgenden personenbezogenen
        Daten von Ihnen:
      </p>
      <p>
        <strong>Login-Daten</strong>
        <br />Ihre Zugangsdaten sind notwendig, um Ihr Konto vor unbefugtem Zugriff zu schützen. Zu
        diesem Zweck sammeln wir: Einen selbst gewählten Loginnamen und ein selbst gewähltes
        Passwort.
      </p>
      <p>
        <strong>Kontaktdaten</strong>
        <br />Wir erfassen Ihre Kontaktdaten (Telefonnummer und E-Mail-Adresse), um den Zugang zu
        Ihrem Konto wiederherstellen zu können, wenn Sie Ihre Zugangsdaten verlieren. Wir verwenden
        Ihre Kontaktdaten auch, um Sie an Beurteilungen und therapeutische Aufgaben im Rahmen der
        Studie oder Behandlung zu erinnern und Sie für die Durchführung des klinischen Interviews zu
        kontaktieren. Wenn wir erfahren, dass Sie während der Behandlung eine akute
        lebensbedrohliche Krise durchmachen, behalten wir uns auch das Recht vor, Sie telefonisch zu
        kontaktieren. Wir bitten Sie auch, uns die Telefonnummer einer Person anzugeben, der Sie
        vertrauen, an die wir uns im Falle einer lebensbedrohlichen Krise wenden können.
      </p>
      <p>
        <strong>Gesundheitsdaten</strong>
        <br />Wir sammeln relevante Gesundheitsdaten, um die Wirksamkeit von Ilajnafsy
        wissenschaftlich zu untersuchen. Wir untersuchen, ob sich die Wirksamkeit je nach Stressoren
        und psychischer Belastung sowie je nach Einsatz der Behandlung und Behandlungsverfahren
        unterscheidet. Zu diesem Zweck verwenden wir Fragebögen zu psychischer Gesundheit (d.h.
        Stimmung, posttraumatische Stresssymptome), Lebensqualität und sozialer Unterstützung. Wir
        erheben diese Daten zu verschiedenen Zeitpunkten während der Studie (einschließlich
        Nachbehandlung und Nachbeobachtung). In der Basisbewertung fragen wir zusätzlich nach
        traumatischen Stressoren und Verlusterfahrungen. Zusätzlich bitten wir Sie, den
        Therapieverlauf (d.h. die Arbeitsgemeinschaft) und alle positiven und negativen
        Auswirkungen, die Sie während der Behandlung erfahren haben, zu bewerten. Wir versuchen
        auch, Personen für ein Feedback-Gespräch am Ende der Behandlung zu kontaktieren. Das
        Feedback-Gespräch wird über einen sicheren Online-Kommunikationsanbieter oder per Telefon
        geführt.
      </p>
      <p>
        Bevor wir uns an der Behandlung beteiligen, verwenden wir Daten aus dem Fragebogen, um
        automatisch zu entscheiden, ob die Behandlung für Sie geeignet ist. Nach der Annahme
        aufgrund der Ergebnisse der Fragebögen bitten wir Sie, einen Termin für ein klinisches
        Interview zu vereinbaren, das über einen sicheren Online-Kommunikationsanbieter oder per
        Telefon durchgeführt wird. Geschulte Interviewer führen das Interview durch, um entscheiden
        zu können, wie geeignet die Behandlung für Sie ist. Im Falle der Erfüllung von
        Ausschlusskriterien für unsere Behandlung (z.B. Suizidalität, psychotische Symptome,
        manische und hypomane Symptome) versuchen wir, Sie über alternative Behandlungsmöglichkeiten
        zu informieren.
      </p>

      <p>
        Zusätzlich werden Ihre Eingaben in den Ilajnafsy-Übungen (Text, Tabellen) gespeichert, so
        dass Sie von anderen Geräten aus darauf zugreifen können. Ihre Einträge sind für Ihren
        Therapeuten, den Betreuer Ihres Therapeuten, Forscher und die Projektkoordinatoren sichtbar.
        Nach Abschluss Ihrer Therapie werden die Texte und Tabellen nach 6 Monaten in unserem System
        gelöscht. Sie können all Ihre Texte und Tabellen jedoch privat speichern und können somit
        auch danach zugreifen. Vor Ablauf der 6 Monate werden wir Sie nochmals erinnern.
      </p>
      <p>
        Wenn Sie das integrierte Messaging-System von Ilajnafsy verwenden, werden Ihre Nachrichten
        an den Server gesendet und gespeichert, so dass Sie über das integrierte Messaging-System
        mit Ihrem Therapeuten oder dem technischen Support kommunizieren können. Die Botschaften
        werden für Ihren Therapeuten, den Betreuer Ihres Therapeuten, den technischen Unterstützer,
        den Projektkoordinator und die Forscher sichtbar sein, um sicherzustellen, dass wir Sie
        bestmöglich unterstützen.
      </p>
      <p>
        <strong>Demographische Daten</strong>
        <br />Für wissenschaftliche Zwecke werden zusätzliche personenbezogene Daten erhoben. Diese
        werden verwendet, um zu untersuchen, ob sich die Wirkung von Ilajnafsy je nach Faktoren wie
        Geschlecht, Alter, Herkunftsland, das aktuelle Wohnsitzland, Bildungshintergrund,
        Familienstand, Anzahl der Kinder und Geschwister, bisherige und aktuelle Behandlung und
        beruflicher Status unterscheiden.
      </p>
      <p>
        Für Vertriebene sammeln wir auch den Grund der Vertreibung, die Zeit seit der Vertreibung
        und die aktuellen Lebensbedingungen, um zu untersuchen, ob sich die Wirkung von Ilajnafsy je
        nach diesen Faktoren unterscheidet.
      </p>
      <p>
        Die Verarbeitung Ihrer Daten basiert auf Ihrer freiwilligen Einwilligung zur Teilnahme an
        der Studie gemäß Artikel 6 Absatz 1 der Allgemeinen Datenschutzverordnung (GDPR). Diese
        Einwilligung können Sie jederzeit widerrufen. Dabei ziehen Sie sich aus der Studie zurück.
      </p>
      <p>
        Wenn Sie die Löschung Ihrer Daten wünschen, senden Sie bitte eine E-Mail an die
        E-Mail-Adresse des Ilajnafsy-Teams:
        <a
          href="mailto:support-ilajnafsy@ueberleben.org"
        >support-ilajnafsy@ueberleben.org</a>
        In diesem Fall werden alle Ihre Daten anonymisiert und nur für wissenschaftliche Zwecke
        verwendet.
      </p>
      <p>
        Ihre Daten werden zusammen mit Ihrem Loginnamen gespeichert, solange die Studie läuft.
        Sobald Sie die Studie abschließen oder abbrechen, werden alle erfassten Daten anonymisiert.
        Dies bedeutet, dass die Daten Ihrer Person nicht mehr zugeordnet werden können. Die anonymen
        Daten werden mindestens 10 Jahre lang gespeichert.
      </p>
      <p>
        <strong>Technische Daten</strong>
        <br />Wenn Sie das Programm Ilajnafsy öffnen, werden die Daten automatisch in den
        Server-Logdateien gespeichert. Dazu gehören: Datum, Uhrzeit, das von Ihnen verwendete
        Betriebssystem, Merkmale der von Ihnen verwendeten Anzeige und des von Ihnen verwendeten
        Browsers.
      </p>
      <p>
        Zusätzlich werden die folgenden Daten gespeichert: Die Größe des übertragenen Datenvolumens,
        ein sogenannter HTTP-Statuscode (z.B. zur Identifizierung einer erfolgreich übertragenen
        Website), die IP-Adresse des zugreifenden Rechners, wobei diese IP-Adresse durch Löschen des
        letzten Oktetts dieser Adresse anonymisiert wird.
      </p>
      <p>
        Die Erhebung und Nutzung der in den Protokolldateien gespeicherten Informationen wird in
        anonymisierter Form zu statistischen Zwecken (z.B. zur Analyse von Nutzungsmustern) und
        damit zur Verbesserung unserer Dienstleistungen verwendet. Da die IP-Adressen wie oben
        beschrieben anonymisiert sind, ist es nicht möglich, die Auswertungsergebnisse einer
        bestimmten IP-Adresse zuzuordnen.
      </p>
      <p>
        Zu Auswertungszwecken werden die Protokolldateien für das aktuelle und vorherige
        Kalenderjahr gespeichert. Nach Ablauf dieser Zeit werden die Protokolldateien gelöscht.
      </p>
      <p>
        <strong>Nutzungsdaten</strong>
        <br />Bei der Nutzung von Ilajnafsy werden Nutzungsdaten gespeichert. Es wird verwendet, um
        anonyme Zugriffsstatistiken zu erstellen und damit Ilajnafsy zu verbessern. Diese Daten
        sagen uns, in welcher Weise und wie oft Ilajnafsy und bestimmte Funktionen des Programms
        genutzt werden. Zu diesem Zweck sammeln wir Zeitstempel für Aktionen im Programm (z.B. den
        Beginn von a) und Zähler für Aktionen im Programm (z.B. die Anzahl der geplanten Aktivitäten
        oder die Anzahl der an Ihren Therapeuten gesendeten Nachrichten).
      </p>
      <p>
        <strong>4. Empfänger der Daten</strong>
      </p>
      <p>
        Die für das Interview und die Behandlung relevanten Daten sind für den zugewiesenen
        Interviewer, Therapeuten, Supervisor des Therapeuten und die Studienkoordinatoren
        zugänglich, solange Sie Teil der Studie sind. Die Kontaktdaten werden gelöscht, sobald Sie
        das Programm abschließen oder beenden. Die Zugangsdaten werden nach der letzten
        Nachbereitung gelöscht. Therapeuten und Interviewer sind in Deutschland, Ägypten und
        Jordanien tätig. Der Hosting-Provider und die freiberuflichen Mitarbeiter der
        Informationstechnologie haben Zugriff auf alle Daten. Diese werden sorgfältig ausgewählt und
        mit einem Auftragsbearbeitungsvertrag versehen. Berichte für unsere Sponsoren (MISEREOR und
        BMZ) spiegeln die Daten nur in aggregierter und anonymisierter Form wider. Forscher haben
        aus wissenschaftlichen Gründen Zugang zu Gesundheits-, demographischen, technischen und
        Nutzungsdaten, um das Programm statistisch auszuwerten und zu verbessern. Im Übrigen erfolgt
        keine Weitergabe an Dritte, es sei denn, Sie haben eingewilligt oder wir sind gesetzlich zur
        Weitergabe verpflichtet.
      </p>
      <p>
        <strong>5. Wo werden Ihre Daten gespeichert?</strong>
      </p>
      <p>
        Ihre Daten werden in Deutschland auf Servern im Rechenzentrum der Hetzner Online GmbH
        gehostet. Dieser Betreiber garantiert die physische Sicherheit der Daten und den Schutz vor
        unbefugtem Zugriff über das Netzwerk. Hetzner erfüllt die ISO 27001, einen Verhaltenskodex,
        der sich auf die Sicherheit der Informations- und Informationstechnologie konzentriert.
      </p>
      <p>
        <strong>6. Wie werden Ihre Daten geschützt?</strong>
      </p>
      <p>
        Die App kommuniziert mit dem Server über verschlüsselte Verbindungen mittels SSL (Secure
        Socket Layer), was verhindert, dass unbefugte Dritte Ihre Daten lesen können. Sowohl Server
        als auch Datenbanken befinden sich hinter Firewalls, um den Zugriff einzuschränken.
      </p>
      <p>
        <strong>7. Cookies</strong>
      </p>
      <p>
        Wir verwenden Cookies und LocalStorage, um Sie eingeloggt zu halten, aber nicht zur
        Verfolgung. Daher verwenden wir nur technisch notwendige Cookies.
      </p>
      <p>
        <strong>8. Aktive Komponenten</strong>
      </p>
      <p>
        Das Programm Ilajnafsy verwendet Java- und Javascript-Anwendungen. Sie können Ihren Browser
        so einstellen, dass er die Ausführung solcher Anwendungen ablehnt oder Sie vorher um eine
        Bestätigung bittet. Dies kann auch durch frei verfügbare Zusatzprogramme erfolgen. Wenn Sie
        diese Anträge jedoch ablehnen, können Sie möglicherweise bestimmte Funktionen der Website
        nicht mehr nutzen.
      </p>
      <p>
        <strong>9. Änderung der Datenschutzpraktiken</strong>
      </p>
      <p>
        Aufgrund der ständigen Veränderungen im Internet, vor allem der Technik und auch der
        jeweiligen Rechtslage, behalten wir uns das Recht vor, unsere Datenschutzpraxis von Zeit zu
        Zeit anzupassen, wenn dies erforderlich wird. Solche Anpassungen unserer
        Datenschutzpraktiken werden dann hier auf dieser Seite mit einer Frist von zwei
        Kalenderwochen bekannt gegeben, sofern dies aufgrund der die Anpassung verursachenden
        Umstände möglich bleibt.
      </p>
      <p>
        <strong>10. Ihre Rechte als Nutzer*in</strong>
      </p>
      <p>
        Bei Verarbeitung Ihrer personenbezogenen Daten gewährt die DSGVO Ihnen als Webseitennutzer
        bestimmte Rechte:
      </p>
      <p>Auskunftsrecht (Art. 15 DSGVO)</p>
      <p>
        Sie haben das Recht eine Bestätigung darüber zu verlangen, ob sie betreffende
        personenbezogene Daten verarbeitet werden; ist dies der Fall, so haben Sie ein Recht auf
        Auskunft über diese personenbezogenen Daten und auf die in Art. 15 DSGVO im einzelnen
        aufgeführten Informationen.
      </p>
      <p>Recht auf Berichtigung und Löschung (Art. 16 und 17 DSGVO)</p>
      <p>
        Sie haben das Recht, unverzüglich die Berichtigung sie betreffender unrichtiger
        personenbezogener Daten und ggf. die Vervollständigung unvollständiger personenbezogener
        Daten zu verlangen.
      </p>
      <p>
        Sie haben zudem das Recht, zu verlangen, dass sie betreffende personenbezogene Daten
        unverzüglich gelöscht werden, sofern einer der in Art. 17 DSGVO im einzelnen aufgeführten
        Gründe zutrifft, z. B. wenn die Daten für die verfolgten Zwecke nicht mehr benötigt werden.
      </p>
      <p>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</p>
      <p>
        Sie haben das Recht, die Einschränkung der Verarbeitung zu verlangen, wenn eine der in Art.
        18 DSGVO aufgeführten Voraussetzungen gegeben ist, z. B. wenn Sie Widerspruch gegen die
        Verarbeitung eingelegt haben, für die Dauer einer etwaigen Prüfung.
      </p>
      <p>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</p>
      <p>
        In bestimmten Fällen, die in Art. 20 DSGVO im Einzelnen aufgeführt werden, haben Sie das
        Recht, die sie betreffenden personenbezogenen Daten in einem strukturierten, gängigen und
        maschinenlesbaren Format zu erhalten bzw. die Übermittlung dieser Daten an einen Dritten zu
        verlangen.
      </p>
      <p>Widerspruchsrecht (Art. 21 DSGVO)</p>
      <p>
        Werden Daten auf Grundlage von Art. 6 Abs. 1 lit. f erhoben (Datenverarbeitung zur Wahrung
        berechtigter Interessen), steht Ihnen das Recht zu, aus Gründen, die sich aus Ihrer
        besonderen Situation ergeben, jederzeit gegen die Verarbeitung Widerspruch einzulegen. Wir
        verarbeiten die personenbezogenen Daten dann nicht mehr, es sei denn, es liegen nachweisbar
        zwingende schutzwürdige Gründe für die Verarbeitung vor, die die Interessen, Rechte und
        Freiheiten der betroffenen Person überwiegen, oder die Verarbeitung dient der
        Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.
      </p>
    </div>
    <div class="arabic">
      <h1>حماية البيانات</h1>
      <p>
        <strong>١. برنامج علاج نفسي وبياناتك</strong>
      </p>
      <p>
        حماية بياناتك وخصوصيتها عند اِستخدام برنامج علاج نفسي هما أمران مهمان بالنسبة لنا. نحن ندرك
        بأننا نطلب في إطار هذا البحث معلومات حساسة والتي تحتاج لحماية قصوى. اِنطلاقاً من هذا السبب
        نقوم بجمع معلومات شخصية قليلة قدر الإمكان ونقوم بحمايتها وفق معيار تقني عالي المستوى.
      </p>
      <p>
        <strong>مركز أوبرليبن, Turmstraße 21, 10559</strong>هوالمسؤول عن حماية بياناتك وفقاً لقانون
        حماية البيانات الأوربي. ريتشارد غرونبرغ هو المشرف على حماية البيانات. د. ماريا بوتشه ( مديرة
        قسم البحث العلمي) مسؤولة عن عملية جمع البيانات
      </p>
      <p>إذا كان لديك أي أسئلة متعلقة بمعلومات الخصوصية التالية فنحن في خدمتك، لاتتردد بالتواصل معنا.</p>
      <p>
        يمكن توجيه الأسئلة المتعلقة بحماية البيانات إلى
        <a
          href="mailto:support-ilajnafsy@ueberleben.org"
        >support-ilajnafsy@ueberleben.org</a>
        أو +49 30 303906 71
      </p>
      <p>
        <strong>٢. بماذا تتعلق حماية البيانات؟</strong>
      </p>
      <p>
        حماية البيانات تدور حول حماية البيانات الشخصية. هذا يشمل البيانات التي يمكن أن تخص الشخص
        بشكل واضح. هذه تتضمن معلومات مثل الاِسم، رقم التعريف، عنوان البريد الإلكتروني أو رقم الهاتف.
        المعلومات التي لا يمكن أن تكون مرتبطة بالهوية الشخصية ليست مضمّنة تحت خانة البيانات الشخصية.
      </p>
      <p>
        عند جمع البيانات الشخصية واِستخدامها فإننا نقتصر بشكل صارم على المعلومات التقنية المطلوبة
        ونحافظ على الشروط القانونية. دائماً عندما يكون ممكناً نقوم بالاِستغناء عن جمع البيانات
        الشخصية. نحن نجمع ونستخدم البيانات الشخصية فقط إذا وافقت حضرتك أو إذا سُمِح لنا قانونياً
        بذلك. المهم لنا أن تكون حضرتك قد فهمت لماذا نقوم بجمع البيانات وبماذا نستخدمها
      </p>
      <p>
        <strong>٣. أي بيانات سوف يتم جمعُها؟</strong>
      </p>
      <p>لإجراء الدراسة نقوم بجمع وبالعمل على البيانات الشخصية التالية:</p>
      <p>
        <strong>بيانات تسجيل الدخول</strong>
        <br />بيانات تسجيل الدخول خاصتك ضرورية لحماية حسابك من الدخول غير القانوني عليه. لهذا الغرض
        نجمع اسم المُستخدم ورقم السر المُختارين من قِبلك.
      </p>
      <p>
        <strong>معلومات التواصل</strong>
        <br />نقوم بجمع معلومات الاِتصال الخاصة بك (رقم هاتفك أو بريدك الإلكتروني) حتى نتمكن من
        اِستعادة معلومات تسجيل الدخول الخاصة بك إلى برنامج علاج نفسي إذا فقدتها وحتى نتمكن من تذكيرك
        بالاِستبيانات والتقيمات والمهام العلاجية التي تعد جزءاً من العلاج في إطار هذه الدراسة كما
        أننا سنتصل بك لإجراء المقابلة التشخيصية. بالإضافة إلى ذلك، إذا علمنا أنك في أزمة خطيرة تهدد
        حياتك، فإننا نحتفظ بالحق في الاِتصال بك على هاتفك. سنطلب منك تزيدنا برقم هاتف الشخص الذي تثق
        به والذي يمكننا الاتصال به في حال حدوث أزمة تهدد حياتك.
      </p>
      <p>
        <strong>البيانات الصحية</strong>
        <br />نحن نجمع البيانات الصحية ذات الصلة للتحقق علمياً من فعالية برنامج علاج نفسي . بالإضافة
        إلى ذلك، نقوم بفحص ما إذا كانت الفعالية تختلف بإختلاف عوامل الضغوط والإجهادات النفسية،
        بالإضافة إلى تطبيق العلاج وعملية العلاج. لهذا الغرض نقوم بجمع اِستبيانات للصحة النفسية (حول
        المزاج، أعراض اضطراب ما بعد الصدمة).و حول جودة الحياة والدعم الاجتماعي . نقوم بجمع هذه
        البيانات في أوقات مختلفة من الدراسة (من ضمنها بعد العلاج مباشرة و تقييم المتابعة بعد فترة من
        العلاج). خلال التقييم الأساسي نقوم ايضاً بسؤالك عن الضغوطات الصادمة وتجارب خسارة الأشخاص .
        إضافة الى ذلك نطلب منك تقييم العملية العلاجية ( التعاون مع المعالج) وكل التأثيرات الإيجابية
        والسلبية التي تواجهها أثناء العلاج . كما أننا نحاول في نهاية العلاج أن نتواصل مرة أخرى لتلقي
        تقييم مرة أخرى من خلال القيام بإجراء مقابلة لجمع التقييم بعد العلاج من خلال تواصل آمن ومحمي
        عبر الانترنت أو من خلال الهاتف.
      </p>
      <p>
        قبل أن نبدأ بالعلاج نستخدم بعض البيانات من الاستبيانات حتى يتم الاختيار تلقائياً اذا ما كان
        العلاج مناسباً لك أو لا. بعد أن تُقبل بنتيجة نتائج الاستبيانات نقوم بالطلب منك أن تحدد موعد
        لاجراء مقابلة تشخيصية تجري عبر اتصال آمن ومحمي من خلال الانترنت أو من خلال الهاتف ويقوم بها
        أخصائيون نفسيون مدربون حتى يقرروا اذا ما كان العلاج المقدم مناسباً لك . في حال وجود معايير
        تستوجب الاستبعاد من العلاج الذي نقدمه مثل( خطورة الانتحار ، الاضطربات الذهانية ، النوبات
        الهوسية او تحت الهوسية ) نحاول أن ننصحك بعلاجات بديلة أخرى .
      </p>
      <p>
        إضافة الى ذلك سيتم حفظ جميع الأشياء التي تقوم بتخزينها خلال التمارين في برنامج علاج نفسي
        مثل( النصوص و الجداول التي تكتبها ) حتى تتمكن من الدخول عليها من أجهزة أخرى . ستكون ايضاً
        هذه المدخلات التي تكتبها مرئية بالنسبة للمعالج الخاص بك والمشرف على المعالجين وللباحثين
        ومنسقي ومشرفي المشروع
      </p>
      <p>
        إذا كنت تستخدم نظام الرسائل المدمج ضمن برنامج علاج نفسي فسيتم ارسال هذه الرسائل عبر الخادم
        وتخزينها بحيث تستطيع من خلال نظام ارسال الرسائل هذا بأن تتواصل مع المعالج الخاص بك ومع الدعم
        التقني للبرنامج. الرسائل سيكون من الممكن رؤيتها من قِبل المعالج الخاص بك والمشرف عليه ومن
        قِبل الدعم التقني للبرنامج ومنسقي المشروع والباحثين فيه حتى تكون على ثقة بأننا نقدم أسرع دعم
        ممكن.
      </p>
      <p></p>
      <p>بالإضافة إلى ذلك ، يتم حفظ إدخالاتك في تمارين علاج نفسي(النصوص والجداول) حتى تتمكن من الوصول إليها من أجهزة أخرى. إدخالاتك ستكون مرئية لمعالجك والمشرف على المعالج والباحثين ومنسقي المشروع. بعد الانتهاء من العلاج ، يتم حذف النصوص والجداول في نظامنا بعد 6 أشهر. ومع ذلك ، يمكنك حفظ جميع النصوص والجداول الخاصة بك بشكل خاص ، وبالتالي يمكنك الوصول إليها أيضاً. سنذكرك مرة أخرى قبل نهاية فترة الستة أشهر.</p>
      <p>
        <strong>البيانات الديموغرافية</strong>
        <br />لأغراضٍ علمية، سيتم جمع المزيد من المعلومات عنك. هذه المعلومات تعمل على التحقق فيما
        إذا كان تأثير برنامج علاج نفسي يختلف اِعتماداً على عوامل مثل: الجنس، العمر، الجنسية، بلد
        الإقامة، التحصيل العلمي، الحالة الاجتماعية، وعدد الأطفال والأشقاء، العلاج السابق والحالي
        والحالة المهنية.
      </p>
      <p>
        بالنسبة للنازحيين من مناطقهم، نقوم أيضاً بجمع معلومات عن سبب النزوح ، والوقت منذ النزوح،
        والظروف المعيشية الحالية من أجل التحقيق في ما إذا كان تأثير برنامج علاج نفسي يختلف تبعا لهذه
        العوامل.
      </p>
      <p>
        تعتمد معالجة بياناتك على موافقتك الطوعية للمشاركة في الدراسة وفقًا للفقرة 1 من المادة 6 من
        اللائحة العامة لحماية البيانات. يمكنك إلغاء هذه الموافقة في أي وقت. بهذا يمكنك الانسحاب من
        الدراسة.
      </p>
      <p>
        إذا كنت ترغب في حذف بياناتك، فيرجى إرسال رسالة بريد إلكتروني إلى عنوان البريد الإلكتروني
        لفريق علاج نفسي
        <a
          href="mailto:support-ilajnafsy@ueberleben.org"
        >support-ilajnafsy@ueberleben.org</a>
        في هذه الحالة، سيتم إخفاء بياناتك واستخدامها للغرض العلمي فقط
      </p>
      <p>
        سيتم تخزين بياناتك مع اسم تسجيل الدخول الخاص بك، طالما أن الدراسة قائمة. بمجرد اِكمال
        الدراسة أو تركها، ستكون جميع البيانات المُجمَعة مجهولة المصدر. هذا يعني أنه لن يعود من
        الممكن معرفة بياناتك. يتم تخزين بياناتك بشكل مجهول وسري لمدة عشر سنوات على الأقل.
      </p>
      <p>
        <strong>البيانات التقنية</strong>
        <br />إذا قمت بالدخول إلى موقع برنامج علاج نفسي، سيتم تخزين البيانات تلقائياً في ملفات
        التسجيل التي يتم إنشاؤها تلقائياً بواسطة الخادم. وتشمل هذه: التاريخ والوقت ونظام التشغيل
        الذي تستخدمه وميزات العرض الذي تستخدمه والمتصفح الذي تستخدمه.
      </p>
      <p>
        بالإضافة الى ذلك سيتم حفظ البيانات التالية: حجم كمية البيانات المنقولة وما يسمى بحالة الرمز
        أو بروتوكول اِنتقال النص الشبكي (مثلاً لتحديد صفحة ويب تم نقلها بنجاح)، عنوان البروتوكول
        الخاص بالوصول إلى الكمبيوتر، علماً ان هذا العنوان يتم جعله مجهولاً من خلال حذف الأرقام
        الثمانية الأخيرة.
      </p>
      <p>
        إن جمع واِستخدام المعلومات المُخزنة في ملفات السجل هو فقط للتقييم المجهول لأغراض إحصائية
        (مثل تحليل أنماط الاِستخدام) وبالتالي لتحسين خدماتنا. أن العناوين الموصوفة أعلاه مجهولة،
        ولذلك لايمكن نَسب نتائج التقييم إلى عنوان بروتوكولي محدد.
      </p>
      <p>
        لأغراض التقييم، يتم حفظ ملفات السجل للسنة التقويمية الحالية والسابقة. بعد هذا الوقت، سيتم
        حذف ملفات السجل.
      </p>
      <p>
        <strong>بيانات اِلاستخدام</strong>
        <br />عند استخدام برنامج علاج نفسي يتم تخزين بيانات الاستخدام واستخدامها لانشاء احصائيات
        مجهولة الهوية وحتى نحسن برنامج علاج نفسي. هذه اليانات تخبرنا بأي طريقة وعدد المرات التي تم
        استخدام برنامج علاج نفسي بها وبعض مزات البرنامج. لهذا الغرض قمنا بإنشاء طوابع زمنية
        للإجراءات في البرنامج (مثل بدء جلسة أ) وعدادات للإجراءات في البرنامج (على سبيل المثال، عدد
        الأنشطة المُخطط لها أو عدد الرسائل المرسلة إلى المعالجين عبر الإنترنت).
      </p>
      <p>
        <strong>٤. متلقي البيانات</strong>
      </p>
      <p>
        سيتم الوصول إلى البيانات ذات الصلة بالمقابلة والعلاج من قِبل القائم بإجراء المقابلة والمعالج
        والمشرف على المعالج ومنسقي الدراسة ما دمت جزءًا من الدراسة. سيتم حذف بيانات الاتصال بمجرد
        اكتمال العلاج أو تركه. سيتم حذف بيانات تسجيل الدخول بعد آخر تقييم للمتابعة. يتواجد المعالجون
        والمقابلون في ألمانيا وكندا ومصر والأردن. يستطيع موفرو خدمات الاستضافة والمتعاونون المستقلون
        في مجال تكنولوجيا المعلومات الوصول إلى جميع البيانات. تعطى البيانات للجهات الراعية على شكل
        مشفر ومجهول الهوية يمكن للباحثين الوصول إلى البيانات الصحية والديمغرافية والتقنية
        والاستخدامية لأسباب علمية لتقييم وتحسين البرنامج إحصائيا، لن يتم نقل البيانات إلى طرف ثالث
        إلا إذا أعطيت موافقتك أو ما لم نتعهد قانونًا بنقل البيانات
      </p>
      <p>
        <strong>٥. أين يتم حفظ بياناتك؟</strong>
      </p>
      <p>
        ستتم اِستضافة بياناتك على خوادم في مراكز الكمبيوتر الألمانية في . Hetzner Online GmbH يضمن
        المشغل الأمان المادي للبيانات والحماية من الوصول غير المصرح به إليها عبر الشبكة. . ISO 27001
        مُعتَمد وفق Hetzner هي عبارة عن مدونة تركز على حماية المعلومات وتقنيات المعلومات.
      </p>
      <p>
        <strong>٦. كيف يتم حماية بياناتك؟</strong>
      </p>
      <p>
        التطبيق يتواصل مع المُخَدم من خلال الاتصالات المشفرة عبر المُقبس أو البروتوكول ذو الطبقة
        الآمنة مما يمنع أي طرف ثالث من قراءة بياناتك بطريقة غير مصرح بها. يقع كل من المُخَدم وبنك
        المعلومات خلف جدار الحماية وذلك لتقييد الدخول.
      </p>
      <p>
        <strong>٧. تطبيقات خاصة بمتصفح الانترنت</strong>
      </p>
      <p>
        نحن نستخدم ملفات تعريف الارتباط لإبقاء تسجيل الدخول الخاص بك، ولكن ليس للتتبع وبالتالي،
        فإننا نستخدم ملفات تعريف الارتباط الضرورية تقنيًا فقط.
      </p>
      <p>
        <strong>٨. العناصر النشطة</strong>
      </p>
      <p>
        يتم اِستخدام تطبيقات (جافا وجافا سكريبت) بشكل جزئي على موقع برنامج علاج نفسي. يمكنك من خلال
        متصفحك إذا لزم الامر. من خلال اِستخدام البرامج الإضافية المناسبة والمتاحة بحرية - حيث يرفض
        تنفيذ مثل هذه التطبيقات أو يطلب تأكيداً مسبقاً. إذا قمت برفض هذه التطبيقات، فقد لا تتمكن من
        اِستخدام بعض ميزات عرض الويب.
      </p>
      <p>
        <strong>9. التغييرات على ممارسة الخصوصية</strong>
      </p>
      <p>
        في ضوء التغيرات المُستمرة في الإنترنت، وخاصة التكنولوجيا والتشريعات ذات الصلة، نحتفظ بالحق
        في تغيير ممارسات الخصوصية الخاصة بنا من وقت لآخر، إذا كان ذلك مطلوباً. ثم يتم الإعلان عن هذه
        التعديلات على ممارسات الخصوصية هنا في هذه الصفحة مع مهلة زمنية في أسبوعين تقويميين، إذا كان
        ذلك ممكناً بسبب الظروف التي تؤدي إلى التعديل.
      </p>
      <p>
        <strong>حقوقك كمستخدم/ة</strong>
      </p>
      <p>عند معالجة بياناتك الشخصية ، تمنحك اللائحة العامة لحماية البيانات حقوقاً معينة كمستخدم لموقع الويب:</p>
      <p>الحق في المعلومات (المادة 15 من اللائحة العامة لحماية البيانات)</p>
      <p>يحق لك طلب تأكيد ما إذا كانت البيانات الشخصية المتعلقة بك قيد المعالجة ؛ إذا كان الأمر كذلك ، فلديك الحق في الحصول على معلومات حول هذه البيانات الشخصية والمعلومات المفصلة في المادة 15 من اللائحة العامة لحماية البيانات.</p>
      <p>الحق في التصحيح والحذف (المادتان 16 و 17 اللائحة العامة لحماية البيانات)</p>
      <p>لديك الحق في طلب تصحيح البيانات الشخصية غير الصحيحة المتعلقة بك ، وإذا لزم الأمر ، إكمال البيانات الشخصية غير الكاملة.</p>
      <p>يحق لك أيضًا طلب حذف البيانات الشخصية المتعلقة بك على الفور إذا تم تطبيق أحد الأسباب المذكورة في المادة 17 من اللائحة العامة لحماية البيانات ، على سبيل المثال ب. إذا لم تعد البيانات مطلوبة للأغراض المتبعة.</p>
      <p>الحق في تقييد المعالجة (المادة 18 من اللائحة العامة لحماية البيانات)</p>
      <p>يحق لك طلب تقييد المعالجة في حالة استيفاء أحد الشروط المدرجة في المادة 18 من اللائحة العامة لحماية البيانات ، على سبيل المثال ب. إذا كنت قد اعترضت على المعالجة طوال مدة الفحص.</p>
      <p>الحق في نقل البيانات (المادة 20 من اللائحة العامة لحماية البيانات)</p>
      <p>في حالات معينة ، مدرجة بالتفصيل في المادة 20 من اللائحة العامة لحماية البيانات ، يحق لك تلقي البيانات الشخصية المتعلقة بك في شكل منظم وشائع ومقروء آليًا أو طلب نقل هذه البيانات إلى جهة خارجية.</p>
      <p>الحق في الاعتراض (المادة 21 من اللائحة العامة لحماية البيانات)</p>
      <p>إذا كانت البيانات قائمة على المادة 6 الفقرة 1 . إذا تم جمعها (معالجة البيانات لحماية المصالح المشروعة) ، يحق لك الاعتراض على معالجة البيانات في أي وقت لأسباب تنشأ عن وضعك الخاص. لن نقوم بعد ذلك بمعالجة البيانات الشخصية ، ما لم تكن هناك أسباب قانونية مقنعة يمكن إثباتها للمعالجة التي تفوق مصالح وحقوق وحريات موضوع البيانات ، أو تعمل على تأكيد أو ممارسة أو الدفاع عن المطالبات القانونية.</p>
    </div>
  </section>
</template>

<script>
export default {}
</script>

<style></style>
